import * as actionType from '../action-type';

const initialState = {
  data: {},
};

const tileReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.UPDATE_TILE_REPORT:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };
    case actionType.RESET_TILE_REPORT:
      return {
        ...state,
        data: {},
      };
    default:
      return state;
  }
};

export default tileReportReducer;
